import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class CategoryLinkService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAll() {
        return this.baseApiFactory.getData<any>('/api/CategoriesLink');
    }

    public Insert(values: any) {
        return this.baseApiFactory.post<boolean>('/api/CategoriesLink', values);
    }

    public Update(value: any) {
        return this.baseApiFactory.put<boolean>('/api/CategoriesLink', value);
    }

    public EffectData(value: any) {
        return this.baseApiFactory.post('/api/CategoriesLink/EffectData', value);
    }
}

lazyRegister.service('CategoryLinkService', CategoryLinkService);
